import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import ReactMarkdown from 'react-markdown';
import _ from "underscore";

import * as cms from "../../shared/repos/cms/cms";
import Loader from '../Loader/Loader';
import * as orderActions from '../../redux/actions/order';
import CheckoutContainer from '../CheckOutContainer/CheckoutContainer';
import CheckoutAlertInline from '../CheckOutContainer/CheckoutAlertInline/CheckoutAlertInline';
import styles from '../../pages/ReviewOrder/ReviewOrder.module.css';
import Button from '../Button/Button';
import SecondaryInput from '../SecondaryInput/SecondaryInput';
import Input from '../Input/Input';
import CheckBox from '../CheckBox/CheckBox';
import * as userRepo from '../../shared/repos/graphql/user';
import * as orderRepo from '../../shared/repos/graphql/order';
import { isDoughProOrder } from '../../shared/utilities/orders';
import * as tagmanagerEvents  from '../../shared/utilities/tagmanagerEvents';
import componentStyles from './ContactDetailsWidget.module.css';
import {setAlertSenderPhone} from "../../redux/actions/user";
import {orderMethods, orderCompleteRequirementMessages, checkoutContactIncompleteSubHeader} from "../../shared/constants/order";
import classes from '../../shared/constants/classes';
import * as checkoutActions from "../../redux/actions/checkout";
import {setErrorState, setValidationErrorMessagesFromApiError, handleFormInput} from "../../shared/utilities/validations";
import PhoneInputWidget from '../PhoneInputWidget/PhoneInputWidget';
import messages from '../../shared/constants/messages';
import cmsKeys from "../../shared/constants/cms";
import { isReviewOrderBrandRefresh, getCheckoutCheckIconSrc } from '../../pages/ReviewOrder/reviewOrderBrandRefreshClasses';

const brandRefreshFieldErrorInfo = require('../PaymentWidget/PaymentInputs/PaymentInputCreditCardLegacy/imgs/brand-refresh-field-error-info.svg');

class ContactDetailsWidget extends Component {
  constructor(props) {
    super(props);

    let firstName = "";
    let lastName = "";
    let email = "";
    let phone = "";
    let phonePhone = "";
    let prefixPhone = "";
    let editContact = false;
    let phoneVerified = false;
    let telephoneVerificationRequired = true;

    const customer = props.order.customer || null;
    const { alertSenderPhone } = this.props;

    if (customer) {
      firstName = customer.firstname;
      lastName = customer.lastname;
      email = customer.email;
      if (customer.phoneTelephone && customer.prefixTelephone) {
        phone = `${customer.prefixTelephone} ${customer.phoneTelephone}`;
        phonePhone = customer.phoneTelephone;
        prefixPhone = customer.prefixTelephone;
      } else {
        phone = customer.telephone;
      }
      editContact = true;
      phoneVerified = customer.telephoneVerified;
      telephoneVerificationRequired = customer.telephoneVerificationRequired;
    }

    const sender = props.checkout.sender || {};

    if (
      sender &&
      (sender.firstName || sender.lastName || sender.email || sender.phone)
    ) {
      firstName = sender.firstName;
      lastName = sender.lastName;
      email = sender.email;
      phone = sender.phone;
      phonePhone = sender.phonePhone ? sender.phonePhone : "";
      prefixPhone = sender.prefixPhone ? sender.prefixPhone : "";
      editContact = true;
    }

    this.state = {
      firstName,
      lastName,
      email,
      phone,
      phonePhone,
      prefixPhone,
      editContact,
      currentPhone: customer ? customer.telephone : "",
      phoneVerified,
      agreePhoneChange: false,
      phoneOTP: null,
      phoneOTPErrMessage: "",
      phoneOTPResend: false,
      phoneOTPResending: false,
      verifiyingPhoneOTP: false,
      openForm: true,
      loading: false,
      alertSenderPhone,
      sender,
      telephoneVerificationRequired,
      content: []
    };
  }

  componentDidMount() {
    this.handleContactBlur();
    cms.getContent([cmsKeys.checkoutPage.ringCentralSmsConsent], this);
  }

  componentDidUpdate() {
    const { alertSenderPhone } = this.state;
    // eslint-disable-next-line react/destructuring-assignment
    if (this.props.alertSenderPhone !== alertSenderPhone) {
      // eslint-disable-next-line react/destructuring-assignment, react/no-did-update-set-state
      this.setState({ alertSenderPhone: this.props.alertSenderPhone });
    }
  }

  getSMSConsent = () => {
    const { content } = this.state;
    return _.find(content, { key: cmsKeys.checkoutPage.ringCentralSmsConsent });
  };

  verifyPhone = () => {
    const { order } = this.props;
    const { telephoneVerificationRequired } = this.state;

    if (!order) {
      return false;
    }

    return isDoughProOrder(order.orderTypeId) && telephoneVerificationRequired;
  };

  hasVerifiedPhone = () => {
    const { phoneVerified } = this.state;

    return phoneVerified;
  };

  isNewPhoneNumber = () => {
    const { phonePhone, currentPhone } = this.state;

    return currentPhone !== phonePhone;
  };

  updatePhoneFromOTP = async () => {
    const { phone, phoneOTP } = this.state;
    const { orderUpdated, order } = this.props;

    if (!order.customer || !phoneOTP) {
      return;
    }

    this.setState({
      loading: true
    });

    let data;

    try {
      const result = await userRepo.confirmCustomerTelephoneOtp(phoneOTP);

      data = result.data;
    } catch (e) {
      this.setState({ loading: false, phoneOTPResend: true });

      if (!e.message) {
        this.setState({
          phoneOTPErrMessage: "Something went wrong! Please try again."
        });

        return;
      }

      this.setState({
        phoneOTPErrMessage: e.message
      });

      return;
    }

    this.setState({
      verifiyingPhoneOTP: false,
      openForm: false,
      phoneOTP: null,
      loading: false,
      currentPhone: phone,
      phoneVerified: data.confirmCustomerTelephoneOtp.telephoneVerified
    });

    order.customer.telephone = phone;
    order.customer.telephoneVerified =
      data.confirmCustomerTelephoneOtp.telephoneVerified;

    orderUpdated(order);
  };

  resendOTP = async () => {
    this.setState({
      phoneOTPResending: true,
      loading: true
    });

    await userRepo.resendCustomerTelephoneOtp();

    this.setState({
      phoneOTPResending: false,
      phoneOTPResend: false,
      phoneOTPErrMessage: "",
      loading: false
    });
  };

  renderOTPConfirmationForm = () => {
    const {
      loading,
      phoneOTPErrMessage,
      phoneOTPResend,
      phoneOTPResending
    } = this.state;

    return (
      <div className={styles.secondaryAddressContainer}>
        {loading ? (
          <div className={styles.createContactLoaderWrapper}>
            <Loader />
          </div>
        ) : null}
        <p>Confirm Text Verification</p>

        <SecondaryInput
          component={this}
          label="Text Verification"
          state="phoneOTP"
          isEdit
        />

        <Button
          customContainerStyles={styles.secondaryButtonContainer}
          handleSubmit={this.updatePhoneFromOTP}
          label="Confirm"
        />

        <div className={componentStyles.resendWrapper}>
          {phoneOTPErrMessage && phoneOTPErrMessage.length ? (
            <p
              className={`${styles.errorMessage} ${componentStyles.errorMessage}`}
            >
              {phoneOTPErrMessage}
            </p>
          ) : null}
          {phoneOTPResend && (
            <button
              disabled={phoneOTPResending}
              className={componentStyles.resendOTPBtn}
              type="button"
              onClick={() => this.resendOTP()}
              tabIndex={0}
              onKeyDown={(e) => e.key === 'Enter' && this.resendOTP()}
            >
              {phoneOTPResending ? "Resending..." : "Resend"}
            </button>
          )}
        </div>
      </div>
    );
  };

  handleContactBlur = field => {
    const {
      checkoutUpdated,
      checkoutErrorsUpdated,
      checkout,
      setAlertSenderPhoneUpdated,
      order
    } = this.props;
    const {
      firstName,
      lastName,
      email,
      phone,
      phonePhone,
      prefixPhone,
      alertSenderPhone
    } = this.state;

    if (!checkout.errors) {
      checkout.errors = {};
    }

    if (
      checkout.sender &&
      firstName === checkout.sender.firstName &&
        lastName === checkout.sender.lastName &&
        email === checkout.sender.email &&
        phone === checkout.sender.phone
    ) {
      return;
    }

    const data = {
      firstName,
      lastName,
      email,
      phone,
      phonePhone,
      prefixPhone
    };
    const customerId = order?.customer?.id;
    tagmanagerEvents.shippingInfo(order.code, data, customerId);
    checkout.sender = data;
    delete checkout.errors[`contact_${field}`];
    if (field === "phone") {
      delete checkout.errors[`contact_${field}Phone`];
    }
    checkoutUpdated(checkout);
    checkoutErrorsUpdated(checkout.errors);
    setAlertSenderPhoneUpdated(alertSenderPhone);
    this.setState({ sender: data, [`${field}ErrorMessage`]: null });
  };

  onPhoneInput = value => {
    this.setState(
      {
        phone: value.telephone,
        phonePhone: value.phone,
        prefixPhone: value.code
      },
      () => this.handleContactBlur("phone")
    );
  };

  handleOnPhoneBlur = phoneData => {
    const { checkout, checkoutUpdated } = this.props;
    if (phoneData.maskValidation && phoneData.additionalValidations === true) {
      this.setState({
        phoneErrorMessage: null
      });
      delete checkout.errors.contact_phone;
      delete checkout.errors.contact_phonePhone;
      checkoutUpdated(checkout);
    } else {
      if (phoneData.maskValidation === false) {
        const errMessage = messages.phoneInput.maskValidation.replace(
          "%s",
          phoneData.mask
        );
        this.setState({
          phoneErrorMessage: errMessage
        });
        checkout.errors.contact_phone = [{ message: errMessage }];
        checkoutUpdated(checkout);
      }

      if (
        phoneData.additionalValidations !== true &&
        phoneData.additionalValidations.length > 0
      ) {
        const errMessage = phoneData.additionalValidations;
        this.setState({
          phoneErrorMessage: errMessage
        });
        checkout.errors.contact_phone = [{ message: errMessage }];
        checkoutUpdated(checkout);
      }
    }
  };

  setContactInformation = async () => {
    const { orderUpdated, order, setAlertSenderPhoneUpdated } = this.props;
    const {
      firstName,
      lastName,
      email,
      phone,
      agreePhoneChange,
      alertSenderPhone
    } = this.state;

    const detailsFilled = firstName && lastName && email && phone;
    if (!detailsFilled) {
      return;
    }

    if (this.verifyPhone() && this.isNewPhoneNumber() && !agreePhoneChange) {
      return;
    }

    this.setState({
      loading: true
    });

    try {
      const res = await orderRepo.addSender(order.code, {
        firstName,
        lastName,
        email,
        phone
      });

      setAlertSenderPhoneUpdated(alertSenderPhone);
      const updateOrder = {
        ...order,
        sender: res.data.createCustomerContactOnOrder.sender,
        customer: res.data.createCustomerContactOnOrder.customer
      };

      if (
        this.verifyPhone() &&
        (!this.hasVerifiedPhone() || this.isNewPhoneNumber())
      ) {
        this.setState({
          verifiyingPhoneOTP: true
        });
      }

      this.setState({
        loading: false,
        editContact: true
      });

      if (order.customer.telephoneVerified && !this.isNewPhoneNumber()) {
        this.setState({
          openForm: false
        });
      }

      orderUpdated(updateOrder);
    } catch (e) {
      setValidationErrorMessagesFromApiError(e, this);

      this.setState({
        loading: false
      });
    }
  };

  getSubscriptionCheckboxParams = () => {
    const {
      orderStatusSubscription,
      subscriptionSelections,
      toggleSubscription
    } = this.props;
    const { alertSenderPhone } = this.state;
    const brandRefresh = isReviewOrderBrandRefresh();
    return {
      onClick: async () => {
        if (orderStatusSubscription) {
          await toggleSubscription(orderStatusSubscription.subscriptionId);
        }
        this.toggleCheckboxOrderUpdate();
      },
      isChecked: orderStatusSubscription
        ? subscriptionSelections.includes(
            orderStatusSubscription.subscriptionId
          )
        : alertSenderPhone,
      label: (() => {
        if (orderStatusSubscription) {
          return orderStatusSubscription.description;
        }
        if (brandRefresh) {
          return 'Receive updates about your order';
        }
        return 'Text order status updates';
      })()
    };
  };

  renderBrandRefreshField = (stateKey, labelText, handleOnBlur) => {
    const {
      [stateKey]: value,
      [`${stateKey}ErrorMessage`]: errorMessage,
    } = this.state;
    const hasValue = Boolean(value);
    const fieldInputId = `brand-refresh-contact-${stateKey}`;
    const fieldErrorId = `${fieldInputId}-error`;

    return (
      <div className={componentStyles.brandRefreshField}>
        <div
          className={[
            componentStyles.brandRefreshFieldShell,
            hasValue ? componentStyles.brandRefreshFieldShellFilled : null,
            errorMessage ? componentStyles.brandRefreshFieldShellHasError : null,
          ]
            .filter(Boolean)
            .join(' ')}
        >
          {!hasValue ? (
            <span className={componentStyles.brandRefreshFieldGhost} aria-hidden="true">
              {labelText}
              {' '}
              <span className={componentStyles.brandRefreshRequired}>*</span>
            </span>
          ) : (
            <span className={componentStyles.brandRefreshFieldLabel} aria-hidden="true">
              {labelText}
              {' '}
              <span className={componentStyles.brandRefreshRequired}>*</span>
            </span>
          )}
          <Input
            inputId={fieldInputId}
            ariaDescribedBy={errorMessage ? fieldErrorId : undefined}
            value={value}
            handleInput={e => handleFormInput(e, this, stateKey)}
            handleOnBlur={handleOnBlur}
            errorMessage={null}
            customContainerStyles={componentStyles.brandRefreshFieldInputWrap}
            theme="Dark"
            label=""
            placeholder=" "
          />
        </div>
        {errorMessage ? (
          <div
            id={fieldErrorId}
            className={componentStyles.brandRefreshFieldErrorRow}
            role="alert"
          >
            <img
              className={componentStyles.brandRefreshFieldErrorInfo}
              src={brandRefreshFieldErrorInfo}
              alt=""
              aria-hidden="true"
            />
            <p className={componentStyles.brandRefreshFieldErrorText}>
              {errorMessage}
            </p>
          </div>
        ) : null}
      </div>
    );
  };

  renderContactOptions = () => {
    const {
      loading,
      editContact,
      agreePhoneChange,
      verifiyingPhoneOTP,
      phoneErrorMessage,
      phonePhone,
      prefixPhone
    } = this.state;
    const { userOrderMethod, completeOrderError } = this.props;
    const brandRefresh = isReviewOrderBrandRefresh();

    const isDelivery = userOrderMethod === orderMethods.delivery;
    const showInlineAlert = brandRefresh
      && completeOrderError === orderCompleteRequirementMessages.contactDetails;

    if (verifiyingPhoneOTP) {
      return this.renderOTPConfirmationForm();
    }
    const subCheckboxParams = this.getSubscriptionCheckboxParams();
    return (
      <div
        className={[
          styles.secondaryAddressContainer,
          brandRefresh ? componentStyles.brandRefreshContactForm : null,
        ]
          .filter(Boolean)
          .join(' ')}
      >
        {/* eslint-disable-next-line jsx-a11y/iframe-has-title */}
        <iframe name="" style={{ display: "none" }} src="about:blank" />
        <form target="" action="about:blank" className="">
          {loading ? (
            <div className={styles.createContactLoaderWrapper}>
              <Loader />
            </div>
          ) : null}

          {!brandRefresh ? (
            <p className="text-dark dark:text-white">
              {`${editContact ? "Edit" : "Add"} Contact Information`}
            </p>
          ) : null}
          {!brandRefresh && !editContact ? (
            <span className={styles.selectionMinor}>
              {" "}
              *Indicates required fields
              {" "}
            </span>
          ) : null}

          {brandRefresh ? (
            <>
              {showInlineAlert ? (
                <CheckoutAlertInline message={completeOrderError} />
              ) : null}
            <div className={componentStyles.brandRefreshFieldsGroup}>
              {this.renderBrandRefreshField(
                'firstName',
                'First name',
                () => this.handleContactBlur('firstName')
              )}
              {this.renderBrandRefreshField(
                'lastName',
                'Last name',
                () => this.handleContactBlur('lastName')
              )}
              {this.renderBrandRefreshField(
                'email',
                'Email',
                () => this.handleContactBlur('email')
              )}
              <PhoneInputWidget
                className={componentStyles.phoneInputContainer}
                customInputStyles={componentStyles.brandRefreshPhoneInput}
                customSelectStyles={componentStyles.phoneSelectStyle}
                brandRefresh
                onInput={e => this.onPhoneInput(e)}
                handleOnBlur={e => this.handleOnPhoneBlur(e)}
                label=""
                placeholder=" "
                errorMessage={phoneErrorMessage}
                phone={phonePhone}
                code={prefixPhone}
                isEdit={false}
                isNumberFormat
              />
            </div>
            </>
          ) : (
            <>
              <SecondaryInput
                component={this}
                label="First Name"
                state="firstName"
                handleOnBlur={() => this.handleContactBlur("firstName")}
                isEdit={editContact}
              />

              <SecondaryInput
                component={this}
                label="Last Name"
                state="lastName"
                handleOnBlur={() => this.handleContactBlur("lastName")}
                isEdit={editContact}
              />

              <SecondaryInput
                component={this}
                label="Email"
                state="email"
                handleOnBlur={() => this.handleContactBlur("email")}
                isEdit={editContact}
              />

              <PhoneInputWidget
                className={componentStyles.phoneInputContainer}
                customInputStyles={componentStyles.phoneInputStyle}
                customSelectStyles={componentStyles.phoneSelectStyle}
                onInput={e => this.onPhoneInput(e)}
                handleOnBlur={e => this.handleOnPhoneBlur(e)}
                label="Phone Number"
                placeholder=" "
                errorMessage={phoneErrorMessage}
                phone={phonePhone}
                code={prefixPhone}
                isEdit={false}
                isNumberFormat
              />
            </>
          )}

          <p className={`${componentStyles.smsConsentText} !text-darkElevationPrimary dark:!text-darkElevationSecondary`}>
            <ReactMarkdown>{this.getSMSConsent()?.value || ""}</ReactMarkdown>
          </p>

          {isDelivery ? (
            <CheckBox
              onClick={subCheckboxParams.onClick}
              isChecked={subCheckboxParams.isChecked}
              label={subCheckboxParams.label}
              checkIconSrc={getCheckoutCheckIconSrc()}
            />
          ) : null}

          {this.isNewPhoneNumber() && this.verifyPhone() && (
            <CheckBox
              onClick={() =>
                this.setState({ agreePhoneChange: !agreePhoneChange })}
              isChecked={agreePhoneChange}
              label="Confirm phone number change. You'll receive text verification number."
              checkIconSrc={getCheckoutCheckIconSrc()}
            />
          )}

          {!this.isNewPhoneNumber() &&
            !this.hasVerifiedPhone() &&
            this.verifyPhone() && (
              <p>
                <small>You&apos;ll receive text verification number.</small>
              </p>
            )}
          {this.verifyPhone() && (
            <Button
              customContainerStyles={styles.secondaryButtonContainer}
              handleSubmit={this.setContactInformation}
              label={editContact ? "Save Changes" : "Add contact"}
            />
          )}
        </form>
      </div>
    );
  };

  toggleCheckboxOrderUpdate = () => {
    let { alertSenderPhone } = this.state;
    const {
      setAlertSenderPhoneUpdated,
      orderStatusSubscription,
      subscriptionSelections
    } = this.props;

    if (orderStatusSubscription) {
      alertSenderPhone = subscriptionSelections.includes(
        orderStatusSubscription.subscriptionId
      );
    } else {
      alertSenderPhone = !alertSenderPhone;
    }
    setAlertSenderPhoneUpdated(alertSenderPhone);
    this.handleContactBlur();
  };

  onExpand = expand => {
    this.setState({ openForm: expand });
  };

  checkRequiredContactFields = sender => {
    if (!sender) {
      return false;
    }

    const requiredFields = ["firstName", "lastName", "phone", "email"];
    let isError = false;

    requiredFields.forEach(field => {
      if (sender[field] == null || sender[field] === "") {
        isError = true;
      }
    });

    return !isError;
  };

  setErrorsFromCheckout = errors => {
    const { state } = this;

    if (!errors) {
      return;
    }

    // eslint-disable-next-line no-restricted-syntax
    for (const [key, value] of Object.entries(errors)) {
      const keyParts = key.split("_");
      if (
        keyParts[0] === "contact" &&
        state[`${keyParts[1]}ErrorMessage`] !== errors[key][0].message
      ) {
        setErrorState(this, keyParts[1], false, value[0].message);
      }
    }
  };

  render() {
    const { userOrderMethod, checkout, setContactFormError, completeOrderError } = this.props;
    const { openForm, sender, editContact } = this.state;
    const brandRefresh = isReviewOrderBrandRefresh();

    const isPickup = userOrderMethod === "PICKUP";
    const senderDefined = this.checkRequiredContactFields(checkout.sender);

    let incomplete = !senderDefined;

    if (this.verifyPhone()) {
      incomplete =
        incomplete || !this.hasVerifiedPhone() || this.isNewPhoneNumber();
    }

    this.setErrorsFromCheckout(checkout.errors);
    setContactFormError(checkout.errors);

    const legacySubHeader = !senderDefined
      ? "Need contact information"
      : `${sender.firstName} ${sender.phone}`;
    const brandSubHeader = senderDefined
      ? `${sender.firstName} ${sender.phone}`
      : checkoutContactIncompleteSubHeader;
    const showSectionAlert = brandRefresh
      && completeOrderError === orderCompleteRequirementMessages.contactDetails;
    const isExpanded = openForm || showSectionAlert;
    const brandExpandedHeader = `${editContact ? 'Edit' : 'Add'} Contact Information`;

    return (
      <div
        className={`
            ${styles.detailsSection}
            ${isPickup ? styles.pickupContactsContainer : null}
          `}
      >
        {!brandRefresh ? (
          <h3
            className={`yourContactDetailsLabel border-b-[3px] border-borderLight h-9
                     font-montserratBold text-lg leading-[22px] tracking-[-0.1px] text-dark dark:text-white`}
          >
            Your Contact Details
          </h3>
        ) : null}

        <CheckoutContainer
          type="contact"
          isAlert={incomplete && !isExpanded}
          header="Your Contact Information"
          expandedHeader={brandRefresh ? brandExpandedHeader : null}
          component={this}
          onChange={() => this.handleContactBlur()}
          onExpand={val => this.onExpand(val)}
          subHeader={brandRefresh ? brandSubHeader : legacySubHeader}
          subHeaderClass={
            senderDefined
              ? classes.checkoutPage.contactInfo.alertMsg.success
              : classes.checkoutPage.contactInfo.alertMsg.error
          }
          expanded={isExpanded}
          className={
            brandRefresh ? componentStyles.brandRefreshContactAccordion : null
          }
        >
          {this.renderContactOptions()}
        </CheckoutContainer>
      </div>
    );
  }
}

ContactDetailsWidget.defaultProps = {
  checkout: {errors: {}},
  orderStatusSubscription: null,
  toggleSubscription: () => {},
  subscriptionSelections: [],
  completeOrderError: '',
};

ContactDetailsWidget.propTypes = {
    order: PropTypes.shape({
      customer: PropTypes.shape(),
      sender: PropTypes.shape(),
      code: PropTypes.string,
      orderTypeId: PropTypes.number
    }).isRequired,
    checkout: PropTypes.shape({
      sender: PropTypes.shape(),
      errors: PropTypes.shape(),
    }),
    orderUpdated: PropTypes.func.isRequired,
    checkoutUpdated: PropTypes.func.isRequired,
    checkoutErrorsUpdated: PropTypes.func.isRequired,
    userOrderMethod: PropTypes.string.isRequired,
    setAlertSenderPhoneUpdated: PropTypes.func.isRequired,
    alertSenderPhone: PropTypes.bool.isRequired,
    orderStatusSubscription: PropTypes.shape({
      defaultValue: PropTypes.bool,
      description: PropTypes.string,
      subscriptionId: PropTypes.string,
    }),
    toggleSubscription: PropTypes.func,
    subscriptionSelections: PropTypes.arrayOf(PropTypes.string),
    setContactFormError: PropTypes.func.isRequired,
    completeOrderError: PropTypes.string,
}

export const mapStateToProps = state => {
  const { userOrderMethod, alertSenderPhone } = state.user;
    return {
        order: state.order,
        checkout: state.checkout,
        userOrderMethod,
        alertSenderPhone,
    };
};

export const mapDispatchToProps = (dispatch) => ({
    orderUpdated: (value) => dispatch(orderActions.orderUpdated(value)),
    setAlertSenderPhoneUpdated: (value) => dispatch(setAlertSenderPhone(value)),
    checkoutUpdated: (value) => dispatch(checkoutActions.checkoutUpdated(value)),
    checkoutErrorsUpdated: (value) => dispatch(checkoutActions.checkoutErrorsUpdated(value)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ContactDetailsWidget);
